import script from "./PageAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./PageAdd.vue?vue&type=script&setup=true&lang=js"

import "./PageAdd.vue?vue&type=style&index=0&id=5b04f15d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b04f15d"]])

export default __exports__